.group {
  display: inline-flex;
  margin: 0;
  padding: 0;
  border: 1px solid var(--control);
  border-radius: var(--radius-m);
}

.option {
  display: grid;
  place-items: center;
  width: 36px;
  height: 34px;
  color: var(--ink-muted);
  cursor: pointer;
  transition:
    background-color var(--duration-fast) var(--ease-out),
    color var(--duration-fast) var(--ease-out);
}

.option + .option {
  border-left: 1px solid var(--rule);
}
.option:hover {
  background: var(--surface-sunken);
}
.option:has(input:checked) {
  background: var(--ink);
  color: var(--surface);
}
.option:has(input:focus-visible) {
  outline: 2px solid var(--accent);
  outline-offset: 2px;
  position: relative;
}

.lang {
  min-width: 40px;
  height: 36px;
  padding: 0 var(--space-2);
  border: 1px solid var(--control);
  border-radius: var(--radius-m);
  background: none;
  font: 500 var(--text-xs) / 1 var(--font-mono);
  letter-spacing: 0.1em;
}

.lang:hover {
  background: var(--surface-sunken);
}
